<template>
  <v-container fluid fill-height justify-center
      align-center>
      <v-flex xs12 sm10 md7 lg4>
        <v-card class="elevation-1">
          <v-toolbar color="primary">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">Create Agency</v-toolbar-title>
          </v-toolbar>
              <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="e1 > 1">Account Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="e1 > 2">Company Details</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">Location</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form v-model="validAcc" ref="form">
            <v-container fluid>
              <v-layout row>
                <v-flex>
                  <v-text-field
                  label="First Name"
                  v-model="agency.user.first_name"
                  :rules="rules.fieldRules"
                  required
                ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                  label="Last Name"
                  v-model="agency.user.last_name"
                  :rules="rules.fieldRules"
                  required
                ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                  label="E-mail"
                  v-model="agency.user.email"
                  :rules="rules.emailRules"
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    label="Password"
                    v-model="agency.user.password"
                    :append-icon="e2 ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (e2 = !e2)"
                    :type="e2 ? 'password' : 'text'"
                    :rules="rules.passwordRules"
                    counter
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs8>
                  <v-checkbox v-model="agency.user.is_provider" :true-value="'1'" :false-value="'0'" label="Provider"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn color="primary" @click.native="e1 = 2" :disabled="!validAcc">Continue</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-form v-model="validDetails" ref="form">
            <v-container fluid>
              <v-layout row>
                <v-flex>
                  <v-text-field
                  label="Company"
                  v-model="agency.user.company"
                  :rules="rules.fieldRules"
                  required
                ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    label="Logo URL"
                    v-model="agency.user.logo_url"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    label="Phone"
                    v-model="agency.user.phone"
                    :rules="rules.phoneValidation"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    label="Website"
                    v-model="agency.user.website"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn color="primary" @click.native="e1 = 3" :disabled="!validDetails">Continue</v-btn>
            <v-btn flat @click.native="e1 = 1">Back</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-form v-model="validLocation" ref="form">
            <v-container fluid>
              <v-layout row>
                <v-flex>
                  <v-select
                    v-bind:items="states"
                    v-model="agency.user.country"
                    label="Country"
                    item-value="text"
                    :rules="rules.fieldRules"
                    autocomplete
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                <v-text-field
                  label="City"
                  v-model="agency.user.city"
                  :rules="rules.fieldRules"
                  required
                ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    label="Address"
                    v-model="agency.user.address"
                    :rules="rules.fieldRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex>
                  <v-text-field
                    label="Zip Code"
                    v-model="agency.user.zip_code"
                    :rules="rules.fieldRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn color="primary" @click.native="post" :disabled="!validLocation">Create</v-btn>
            <v-btn flat @click.native="e1 = 2">Back</v-btn>
          </v-form>
        </v-stepper-content>
        <div row>
            <v-flex xs10 offset-xs1>
              <v-alert
                class="auth"
                :color="alert.type"
                icon="check_circle"
                :value="alert.status"
                transition="scale-transition"
              >
                {{ alert.message }}
              </v-alert>
            </v-flex>
          </div>
      </v-stepper-items>
    </v-stepper>
        </v-card>
      </v-flex>

  </v-container>
</template>

<script>
import axios from "axios";
import { countryCodesSingle } from "../../../helpers/countryCodes.js";
export default {
  data() {
    return {
      agency: {
        user: {
          approved: true
        }
      },
      e1: 0,
      e2: true,
      validAcc: true,
      validDetails: true,
      validLocation: true,
      alert: {
        status: false,
        message: null,
        type: null
      },
      rules: {
        fieldRules: [v => !!v || "Field is required"],
        phoneValidation: [v => /^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."],
        passwordRules: [
          v => !!v || "Field is required",
          v => v.length >= 8 || "Password must be at least 8 characters"
        ],
        passwordRulesConfirm: [
          v => !!v || "Field is required",
          v => v == this.user.password || "Password not confirmed"
        ],
        emailRules: [
          v => !!v || "E-mail is required",
          v =>
            /\S+@\S+\.\S+/.test(v) ||
            "E-mail must be valid"
        ]
      },
      states: countryCodesSingle
    };
  },
  methods: {
    alerting() {
      this.alert.status = !this.alert.status;
      setTimeout(() => {
        this.alert.status = !this.alert.status;
      }, 2500);
    },
    goBack() {
      this.$router.push("/admin/agencies");
    },
    post() {
      axios
        .post("/users", this.agency)
        .then(res => {
          this.alert.message = "You have registered successfully.";
          this.alert.type = "success";
          this.alerting();
          setTimeout(() => {
            this.$router.push("/admin/agencies");
          }, 2000);
        })
        .catch(err => {
          this.alert.message = "There was an issue with your registration.";
          this.alert.type = "error";
          this.alerting();
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/Agencies/AgenciesNew.vue